<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ title }}</h2>
    </header>

    <list class="view__content"
      :data="entries()"
      :fields="headers()"
      :pagination="pagination"
      :hideCreate="false"
      @paginate="paginate"
      @action="action" />
  </article>
</template>

<script>
import L from 'services/Localization'
import List from 'components/layout/list'
import { mapGetters } from 'vuex'

export default {
  name: 'groups',
  components: { List },
  beforeCreate() {
    this.$store.dispatch('getAllGroups', { includeMembers: true })
  },
  data() {
    return {
      title: L.localize('Settings_Group_Index_Title'),
      group: {}
    }
  },
  computed: {
    ...mapGetters({
      groups: 'allGroups',
      pagination: 'allGroupsPagination'
    })
  },
  methods: {
    paginate(pageNumber) {
      this.$store.dispatch('getAllGroups', {
        page: pageNumber
      })
    },
    action(command) {
      switch (command.name) {
        case 'detail':
          this.$router.push({name: 'group', params: { id: command.item.id }})
          break;
        case 'create':
          this.$router.push({name: 'group-create'})
          break;
      }
    },
    entries: function() {
      return this.groups
    },
    headers: function() {
      let headers = [
        { prop: 'name', label: L.localize('Label_Name') },
        { prop: 'description', label: L.localize('Label_Description') },
        { prop: 'membersCount', label: L.localize('Label_MembersCount') }
      ]
      return headers
    }
  }
}
</script>



// WEBPACK FOOTER //
// Groups.vue?374eb26b